import { AxiosPromise } from 'axios';
import { http } from 'services';

import * as Types from './types';
import { getCaptchaToken } from 'helpers/captcha';

export const List = async ({ date }): Promise<AxiosPromise<{ data: { data: unknown; }; }>> => {
  const token = await getCaptchaToken()

  return http.request.get<{ data: { data: unknown } }>(`/application/open_source/stat`, {
    headers: {
      ...(token ? { 'X-Turnstile-Token': token } : null)
    },
    params: {
      date: date ? date : null
    }
  });
};

export const StatByDocument = async ({
  document_id,
}): Promise<AxiosPromise<{
  data: {
    statuses: Types.IEntity.Status;
    months: Types.IEntity.Month[];
    rating: {
      avg: number;
      count: number;
    };
  };
}>> => {
  const token = await getCaptchaToken()

  return http.request.get(`/application/open-source/stat-by-document`, {
    headers: {
      ...(token ? { 'X-Turnstile-Token': token } : null)
    },
    params: {
      document_id
    }
  });
};

export const User = (): AxiosPromise<{ data: Types.IEntity.User }> => {
  return http.request.get<{ data: Types.IEntity.User }>(`/application/stat/user`);
};
